import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgNearMe = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="m9.1 14.753-6.475-2.625a.9.9 0 0 1-.475-.387 1.07 1.07 0 0 1-.15-.538q0-.274.163-.537a.95.95 0 0 1 .487-.388L18 4.578q.3-.125.575-.05t.475.275.275.475a.87.87 0 0 1-.05.575l-5.7 15.35a.95.95 0 0 1-.387.488 1 1 0 0 1-.538.162q-.275 0-.537-.15a.9.9 0 0 1-.388-.475z"
      />
    </Svg>
  );
};
export default SvgNearMe;
